export const AUTH_LANDING_PAGE_URL = '/dashboard';
export const UNAUTH_LANDING_PAGE_URL = '/login';
